import React from "react";
import { Input, Button } from "semantic-ui-react";
import PropTypes from "prop-types";

const ChatBotInput = ({
  input,
  setInput,
  handleSend,
  handleKeyPress,
  isStreaming,
  handleCancelStream,
}) => (
  <div className="chatbot-input-container">
    <Input
      fluid
      className="chatbot-input"
      value={input}
      onChange={(e) => setInput(e.target.value)}
      onKeyPress={handleKeyPress}
      disabled={isStreaming}
      placeholder="Type a message..."
    />
    {isStreaming ? (
      <Button
        circular
        icon="stop"
        color="red"
        className="chatbot-cancel-button"
        onClick={handleCancelStream}
      />
    ) : (
      <Button
        circular
        icon="send"
        className="chatbot-send-button"
        onClick={() => handleSend(input)}
      />
    )}
  </div>
);

ChatBotInput.propTypes = {
  input: PropTypes.string.isRequired,
  setInput: PropTypes.func.isRequired,
  handleSend: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  isStreaming: PropTypes.bool.isRequired,
  handleCancelStream: PropTypes.func.isRequired,
};

export default ChatBotInput;
